<div class="nav-container-1 project-container">
  <mat-tab-group (selectedTabChange)="tabClick($event)">
    <mat-tab class="mat-tab-label-content" label="Elements"> 

      <kendo-grid [kendoGridBinding]="elementList" [sortable]="true" [resizable]="true" 
        [reorderable]="true" [pageSize]="15"  [filterable]="enableElementFilter" [pageable]="true" id="grvEDMOrgList">
        <ng-template kendoPagerTemplate>
          <div class="k-pager-left">
            <kendo-pager-info></kendo-pager-info> 
          </div>
          <div class="k-pager-right">
            <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
            <kendo-pager-input></kendo-pager-input>
            <kendo-pager-next-buttons></kendo-pager-next-buttons>
          </div>
        </ng-template>
        <ng-template kendoGridToolbarTemplate>
          <div class="k-grid-toolbar-content d-flex justify-content-end">
            <div class="pagination-container">
              <button class="btn btn-primary" (click)="AddNewData('element')">Add New
                Element</button>
            </div>
            <div class="icon-wrap" style="margin-left: 1%;">
              <i class="fa fa-filter" style="float: right;font-size: 18px;" title="Filter" (click)="toggleFilter('element')"
                aria-hidden="true"></i>           
            </div>
          </div>
        </ng-template> 
        <kendo-grid-column title="SL No" field="index" width="150">
          <!-- <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            {{rowIndex + 1}}
          </ng-template> -->
        </kendo-grid-column>
        <kendo-grid-column title="Description" field="tE_Description" width="150">
        </kendo-grid-column>
        <kendo-grid-column title="Active Status"  field="active_status" width="150">                 
        </kendo-grid-column>
        <kendo-grid-column title="Action" width="80" class="text-center">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <div #divIcon class=" icon-container d-flex align-items-center">
              <i class="fa fa-pencil" title="Edit" (click)="editHandler('element',dataItem)"></i>             
            </div>
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </mat-tab>

    <mat-tab class="mat-tab-label-content" label="Items">

      <kendo-grid [kendoGridBinding]="ItemsList" [sortable]="true" [resizable]="true"
        [reorderable]="true"  [filterable]="enableitemFilter" [pageSize]="15" [pageable]="true" id="grvEDMOrgList">
        <ng-template kendoPagerTemplate>
          <div class="k-pager-left">
            <kendo-pager-info></kendo-pager-info>
          </div>
          <div class="k-pager-right">
            <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
            <kendo-pager-input></kendo-pager-input>
            <kendo-pager-next-buttons></kendo-pager-next-buttons>
          </div>
        </ng-template>

        <ng-template kendoGridToolbarTemplate>
          <div class="k-grid-toolbar-content d-flex justify-content-end">
            <div class="pagination-container">
              <button  class="btn btn-primary" (click)="AddNewData('items')">Add New
                Items</button>
            </div>
            <div class="icon-wrap" style="margin-left: 1%;">
              <i class="fa fa-filter" style="float: right;font-size: 18px;" title="Filter" (click)="toggleFilter('items')"
                aria-hidden="true"></i>           
            </div>
          </div>
        </ng-template>
        <kendo-grid-column title="SL No" field="index" width="150">
          <!-- <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            {{rowIndex + 1}}
          </ng-template>  -->
        </kendo-grid-column>
        <kendo-grid-column title="Description" field="tI_Description" width="150">
        </kendo-grid-column>
        <kendo-grid-column title="Active Status"  field="active_status" width="150">                 
        </kendo-grid-column>
        <kendo-grid-column title="Action" width="80" class="text-center">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <div #divIcon class=" icon-container d-flex align-items-center">
              <i class="fa fa-pencil" title="Edit" (click)="editHandler('items',dataItem)"></i>            
            </div>
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </mat-tab>

    <mat-tab class="mat-tab-label-content" label="Configure">
 
      <kendo-grid [kendoGridBinding]="DiscElementItemList" [sortable]="true" [resizable]="true"
        [reorderable]="true"  [filterable]="enableconfigureFilter" [pageSize]="15" [pageable]="true" id="grvEDMOrgList">
        <ng-template kendoPagerTemplate>
          <div class="k-pager-left"> 
            <kendo-pager-info></kendo-pager-info>
          </div>
          <div class="k-pager-right">
            <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
            <kendo-pager-input></kendo-pager-input>
            <kendo-pager-next-buttons></kendo-pager-next-buttons>
          </div>
        </ng-template>
        <ng-template kendoGridToolbarTemplate>
          <div class="k-grid-toolbar-content d-flex justify-content-end">
            <div class="pagination-container">
              <button class="btn btn-primary" (click)="AddNewData('Configure')">Add New
                Configure</button>
            </div>
            <div class="icon-wrap" style="margin-left: 1%;">
              <i class="fa fa-filter" style="float: right;font-size: 18px;" title="Filter" (click)="toggleFilter('Configure')"
                aria-hidden="true"></i>           
            </div>
          </div>
        </ng-template>
        <kendo-grid-column title="SL No" field="index" width="150">
          <!-- <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            {{rowIndex + 1}}
          </ng-template> -->
        </kendo-grid-column>
        <kendo-grid-column title="Discipline" field="deD_Description" width="150">
        </kendo-grid-column>
        <kendo-grid-column title="Elements" field="tE_Description" width="150">
        </kendo-grid-column>
        <kendo-grid-column title="Items" field="tI_Description" width="150">
        </kendo-grid-column>
        <kendo-grid-column title="Active Status"  field="active_status" width="150">                 
        </kendo-grid-column>
        <kendo-grid-column title="Action" width="80" class="text-center">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <div #divIcon class=" icon-container d-flex align-items-center">
              <i class="fa fa-pencil" title="Edit" (click)="editHandler('Configure',dataItem)"></i>            
            </div> 
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </mat-tab>
  </mat-tab-group>
</div> 
